import { render, staticRenderFns } from "./templete-list.vue?vue&type=template&id=679fa534&scoped=true&"
import script from "./templete-list.vue?vue&type=script&lang=js&"
export * from "./templete-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679fa534",
  null
  
)

export default component.exports